
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minhas-ofertas",
      function () {
        return require("private-next-pages/minhas-ofertas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minhas-ofertas"])
      });
    }
  